import React from "react";
import {PieChart, Pie, Cell, Tooltip, ResponsiveContainer} from "recharts";

const RADIAN = Math.PI / 180;
const PERCENT_CUTOFF = 4;

const renderCustomizedLabel = ({cx, cy, midAngle, outerRadius, percent, index, name}) => {
    if (percent * 100 < PERCENT_CUTOFF) return null;

    const radius = outerRadius + 20;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const percentage = (percent * 100).toFixed(1);

    return (
        <text x={x} y={y} fill="black" textAnchor="middle" dominantBaseline="central" fontSize={12}>
            <tspan x={x} dy="-0.5em">
                {name}
            </tspan>
            <tspan x={x} dy="1.5em">{`${percentage}%`}</tspan>
        </text>
    );
};

const PieChartHook = ({headingText = "", style = {}, graphData = {}, backgroundColor = []}) => {
    if (!graphData?.labels || !graphData?.data || graphData.labels.length !== graphData.data.length) {
        return <div>Error: Invalid data provided.</div>;
    }

    const total = graphData.data.reduce((acc, val) => acc + val, 0);
    const data = graphData.labels.map((label, index) => ({
        name: label,
        value: graphData.data[index],
    }));

    const COLORS =
        backgroundColor.length > 0
            ? backgroundColor
            : [
                  "#00BFFF",
                  "#FFC107",
                  "#4CAF50",
                  "#FF5722",
                  "#9C27B0",
                  "#3F51B5",
                  "#FF9800",
                  "#009688",
                  "#E91E63",
                  "#795548",
              ];

    console.log("backgroundColor", backgroundColor);
    return (
        <div>
            <p className="piechart-text" style={{fontWeight: "bold", textAlign: "center"}}>
                {headingText}
            </p>
            <div style={style} className="piechart">
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={110}
                            label={({...props}) => {
                                const percent = props.percent;
                                const name = data[props.index].name;
                                return renderCustomizedLabel({...props, percent, name});
                            }}
                            isAnimationActive={false}
                        >
                            {data.map((entry, index) => {
                                const percent = (entry.value / total) * 100;
                                return (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={percent >= PERCENT_CUTOFF ? COLORS[index % COLORS.length] : "transparent"}
                                    />
                                );
                            })}
                        </Pie>
                        <Tooltip
                            formatter={(value, name) => [`${Number(value).toFixed(1)}`, name]}
                            labelFormatter={() => ""}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default PieChartHook;
